import io from 'socket.io-client';

const DEUSSOCKET = process.env.REACT_APP_SOCKET_URL;

const socketOptions = process.env.NODE_ENV === 'production' 
  ? { 
      path: '/deus/socket.io', 
      transports: ['websocket', 'polling'], 
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000
    }
  : {
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000
    };

const deusSocket = io(DEUSSOCKET, socketOptions);

// Setup global error handling for debugging
deusSocket.on('connect_error', (error) => {
  console.error('Socket connection error:', error);
});

deusSocket.on('connect', () => {
  console.log('Socket connected with ID:', deusSocket.id);
});

deusSocket.on('disconnect', (reason) => {
  console.log('Socket disconnected. Reason:', reason);
});

// Enhanced socket with auth
const sendWithAuth = (event, data, callback) => {
  // Get auth from localStorage
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user');
  
  // Create auth object
  const auth = token && userId ? { token, userId } : null;
  
  // Pass data and auth as separate parameters
  if (callback) {
    deusSocket.emit(event, data, auth, callback);
  } else {
    deusSocket.emit(event, data, auth);
  }
};

// console.log({DEUSSOCKET});

export { 
  deusSocket,
  sendWithAuth
};